import React from "react"
import * as Order from "../../../dtos/orderResponse"
import {Box, Typography} from "@mui/material"
import {makeStyles} from "tss-react/mui"
import {PurcsPreview} from "@vp/react-product-preview"
import {getAccessToken} from "../../../utils/auth"
import {PreviewModes} from "@vp/react-product-preview"

interface ItemDetailsProps {
	lineItem: Order.LineItem
	isOrderLegacy: boolean
	locale: string
}

const useStyles = makeStyles()({
	title: {
		color: "var(--text-primary, rgba(0, 0, 0, 0.87))",
		fontFeatureSettings: "'liga' off, 'clig' off",
		fontSize: "16px",
		fontStyle: "normal",
		fontWeight: 500,
		lineHeight: "175%",
		letterSpacing: "0.15px",
	},
	idTitle: {
		color: "var(--text-secondary, rgba(0, 0, 0, 0.60))",
		fontFamily: "Helvetica Neue",
		fontSize: "12px",
		fontStyle: "normal",
		fontWeight: 700,
		lineHeight: "100%",
		display: "flex",
		alignItems: "baseline",
	},
	preview: {
		width: "84px",
		height: "84px",
		borderRadius: "4px",
	},
	details: {
		display: "flex",
		flexDirection: "column",
		alignItems: "flex-start",
		gap: "4px",
	},
	container: {
		display: "flex",
		alignItems: "center",
		gap: "16px",
		alignSelf: "stretch",
	},
})

export default function ItemDetails(props: ItemDetailsProps) {
	const {classes} = useStyles()

	function getDocumentUrl() {
		return props.isOrderLegacy ? props.lineItem.livePreviewUrl : props.lineItem.documentUrl
	}
	return (
		<div className={classes.container}>
			{props?.lineItem?.livePreviewUrl ? (
				<img
					className={classes.preview}
					src={props.lineItem.livePreviewUrl}
					alt={props.lineItem.productName}
				/>
			) : (
				<Box className={classes.preview}>
					<PurcsPreview
						purcsOrigin="https://lookup.previews.cimpress.io"
						requestor="care-console"
						previewMode={PreviewModes.FirstPageOnly}
						bearerToken={getAccessToken()}
						docRefURL={getDocumentUrl()}
						locale={props.locale}
						coreProductKey={props.lineItem?.productKey}
						optionSelections={props.lineItem?.purcsData?.optionSelections}
						width={300}
						previewInstructionsUri={props.lineItem?.purcsData?.previewInstructionsUri}
						style={{display: "block", width: "100%"}}
					/>
				</Box>
			)}

			<div className={classes.details}>
				<Typography className={classes.title}>
					{props.lineItem.productName ? props.lineItem.productName : "Unknown"}
				</Typography>

				<div className={classes.idTitle}>
					<Typography style={{fontWeight: 700}}>ID: </Typography>
					<Typography style={{fontWeight: 400}}>{`${" "} ${props.lineItem.id}`}</Typography>
				</div>
			</div>
		</div>
	)
}
